import { NgModule } from '@angular/core';
import { OptionModule } from '../abstract/option.module';
import { OptionTextComponent } from './option-text.component';

@NgModule({
  imports: [
    OptionModule,
  ],
  declarations: [OptionTextComponent],
  exports:[OptionTextComponent],
})
export class OptionTextModule { }
